// import "@/App.css";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import Layout from "@/components/Layout";
// import HomePage from "@/pages/HomePage";
// import TreatmentsPage from "@/pages/TreatmentsPage";
// import HospitalsPage from "@/pages/HospitalsPage";
// import WellnessPage from "@/pages/WellnessPage";
// import AboutPage from "@/pages/AboutPage";
// import ContactPage from "@/pages/ContactPage";
// import BlogPage from "@/pages/BlogPage";
// import BlogDetailPage from "@/pages/BlogDetailPage";
// import CareersPage from "@/pages/CareersPage";
// import CostComparisonPage from "@/pages/CostComparisonPage";
// import TestimonialsPage from "@/pages/TestimonialsPage";
// import PartnersPage from "@/pages/PartnersPage";
// import StaticPage from "@/pages/StaticPage";
// import FAQPage from "@/pages/FAQPage";
// import MedicalVisaPage from "@/pages/MedicalVisaPage";
// import PartnerWithUsPage from "@/pages/PartnerWithUsPage";
// import DoctorsPage from "@/pages/DoctorsPage";
// import AdminLoginPage from "@/pages/AdminLoginPage";
// import AdminDashboard from "@/pages/AdminDashboard";
// import OurServices from "./pages/OurServices";
// import TreatmentLandingPage from "./pages/TreatmentLandingPage";
// import ThankYou from "./components/ThankYou";

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route element={<Layout />}>
//           <Route path="/" element={<HomePage />} />
//           <Route path="/treatments" element={<TreatmentsPage />} />
//           <Route
//             path="/treatments/:treatmentSlug"
//             element={<TreatmentLandingPage />}
//           />
//           <Route path="/services" element={<OurServices />} />
//           <Route path="/hospitals" element={<HospitalsPage />} />
//           <Route path="/wellness" element={<WellnessPage />} />
//           <Route path="/doctors" element={<DoctorsPage />} />
//           <Route path="/about" element={<AboutPage />} />
//           <Route path="/contact" element={<ContactPage />} />
//           <Route path="/thank-you" element={<ThankYou />} />
//           <Route path="/blog" element={<BlogPage />} />
//           <Route path="/blog/:slug" element={<BlogDetailPage />} />
//           <Route path="/careers" element={<CareersPage />} />
//           <Route path="/cost-comparison" element={<CostComparisonPage />} />
//           <Route path="/testimonials" element={<TestimonialsPage />} />
//           <Route path="/partners" element={<PartnersPage />} />
//           <Route path="/faq" element={<FAQPage />} />
//           <Route path="/medical-visa" element={<MedicalVisaPage />} />
//           <Route path="/partner-with-us" element={<PartnerWithUsPage />} />
//           <Route path="/page/:slug" element={<StaticPage />} />
//         </Route>
//         <Route path="/admin" element={<AdminLoginPage />} />
//         <Route path="/admin/dashboard" element={<AdminDashboard />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;



import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import TreatmentsPage from "@/pages/TreatmentsPage";
import HospitalsPage from "@/pages/HospitalsPage";
import WellnessPage from "@/pages/WellnessPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import CareersPage from "@/pages/CareersPage";
import CostComparisonPage from "@/pages/CostComparisonPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import PartnersPage from "@/pages/PartnersPage";
import StaticPage from "@/pages/StaticPage";
import FAQPage from "@/pages/FAQPage";
import MedicalVisaPage from "@/pages/MedicalVisaPage";
import PartnerWithUsPage from "@/pages/PartnerWithUsPage";
import DoctorsPage from "@/pages/DoctorsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import OurServices from "./pages/OurServices";
import TreatmentLandingPage from "./pages/TreatmentLandingPage";
import ThankYou from "./components/ThankYou";
import CardiacSurgeryPage from "./pages/treatments/CardiacSurgeryPage";
import OncologyPage from "./pages/treatments/OncologyPage";
import BreastReductionPage from "./pages/treatments/BreastReductionPage";
import DownloadBrochureModal from "./components/DownloadBrochureModal";
import LiposuctionTummyTuckPage from "./pages/treatments/LiposuctionTummyTuckPage";
import BoneMarrowTransplantPage from "./pages/treatments/BoneMarrowTransplantPage";
import DentalPage from "./pages/treatments/DentalPage";
import HipReplacementPage from "./pages/treatments/HipReplacementPage";
import IVFFertilityPage from "./pages/treatments/IVFFertilityPage";
import KidneyTransplantPage from "./pages/treatments/KidneyTransplantPage";
import KneeReplacementPage from "./pages/treatments/KneeReplacementPage";
import LiverTransplantPage from "./pages/treatments/LiverTransplantPage";
import OrganTransplantPage from "./pages/treatments/OrganTransplantPage";
import OrthopaedicsPage from "./pages/treatments/OrthopaedicsPage";
import PlasticSurgeryPage from "./pages/treatments/PlasticSurgeryPage";
import ScrollToTop from "./components/ScrollToTop";

function GTMPageTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <GTMPageTracker />
       <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/brochure" element={<DownloadBrochureModal />} />
          <Route path="/treatments" element={<TreatmentsPage />} />
          {/* ✅ Dedicated routes — GTM can target exact URLs */}
          <Route path="/treatments/cardiac-surgery" element={<CardiacSurgeryPage />} />
          <Route path="/treatments/oncology" element={<OncologyPage />} />
          <Route path="/treatments/breast-reduction" element={<BreastReductionPage />} />
          <Route path="/treatments/liposuction-tummy-tuck" element={<LiposuctionTummyTuckPage />} />
          <Route path="/treatments/bone-marrow-transplant" element={<BoneMarrowTransplantPage />} />
          <Route path="/treatments/dental-care" element={<DentalPage />} />
          <Route path="/treatments/hip-replacement" element={<HipReplacementPage />} />
          <Route path="/treatments/ivf-fertility" element={<IVFFertilityPage />} />
          <Route path="/treatments/kidney-transplant" element={<KidneyTransplantPage />} />
          <Route path="/treatments/knee-replacement" element={<KneeReplacementPage />} />
          <Route path="/treatments/liver-transplant" element={<LiverTransplantPage />} />
          <Route path="/treatments/organ-transplant" element={<OrganTransplantPage />} />
          <Route path="/treatments/orthopaedics" element={<OrthopaedicsPage />} />
          <Route path="/treatments/plastic-surgery" element={<PlasticSurgeryPage />} />

          {/* Fallback for any other slugs */}
          {/* <Route path="/treatments/:treatmentSlug" element={<TreatmentLandingPage />} /> */}

          <Route path="/services" element={<OurServices />} />
          <Route path="/hospitals" element={<HospitalsPage />} />
          <Route path="/wellness" element={<WellnessPage />} />
          <Route path="/doctors" element={<DoctorsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/cost-comparison" element={<CostComparisonPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/medical-visa" element={<MedicalVisaPage />} />
          <Route path="/partner-with-us" element={<PartnerWithUsPage />} />
          <Route path="/page/:slug" element={<StaticPage />} />
        </Route>
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;